/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCorporationCorporationIdMiningObservers200Ok
 */
export interface GetCorporationCorporationIdMiningObservers200Ok {
    /**
     * last_updated string
     * @type {Date}
     * @memberof GetCorporationCorporationIdMiningObservers200Ok
     */
    lastUpdated: Date;
    /**
     * The entity that was observing the asteroid field when it was mined.
     * 
     * @type {number}
     * @memberof GetCorporationCorporationIdMiningObservers200Ok
     */
    observerId: number;
    /**
     * The category of the observing entity
     * @type {string}
     * @memberof GetCorporationCorporationIdMiningObservers200Ok
     */
    observerType: GetCorporationCorporationIdMiningObservers200OkObserverTypeEnum;
}


/**
 * @export
 */
export const GetCorporationCorporationIdMiningObservers200OkObserverTypeEnum = {
    Structure: 'structure'
} as const;
export type GetCorporationCorporationIdMiningObservers200OkObserverTypeEnum = typeof GetCorporationCorporationIdMiningObservers200OkObserverTypeEnum[keyof typeof GetCorporationCorporationIdMiningObservers200OkObserverTypeEnum];


/**
 * Check if a given object implements the GetCorporationCorporationIdMiningObservers200Ok interface.
 */
export function instanceOfGetCorporationCorporationIdMiningObservers200Ok(value: object): value is GetCorporationCorporationIdMiningObservers200Ok {
    if (!('lastUpdated' in value) || value['lastUpdated'] === undefined) return false;
    if (!('observerId' in value) || value['observerId'] === undefined) return false;
    if (!('observerType' in value) || value['observerType'] === undefined) return false;
    return true;
}

export function GetCorporationCorporationIdMiningObservers200OkFromJSON(json: any): GetCorporationCorporationIdMiningObservers200Ok {
    return GetCorporationCorporationIdMiningObservers200OkFromJSONTyped(json, false);
}

export function GetCorporationCorporationIdMiningObservers200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationCorporationIdMiningObservers200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'lastUpdated': (new Date(json['last_updated'])),
        'observerId': json['observer_id'],
        'observerType': json['observer_type'],
    };
}

export function GetCorporationCorporationIdMiningObservers200OkToJSON(json: any): GetCorporationCorporationIdMiningObservers200Ok {
    return GetCorporationCorporationIdMiningObservers200OkToJSONTyped(json, false);
}

export function GetCorporationCorporationIdMiningObservers200OkToJSONTyped(value?: GetCorporationCorporationIdMiningObservers200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'last_updated': ((value['lastUpdated']).toISOString().substring(0,10)),
        'observer_id': value['observerId'],
        'observer_type': value['observerType'],
    };
}

